export default {"src":"/_next/static/media/dining.f58ffedd.svg","height":17,"width":30,"blurWidth":0,"blurHeight":0};